import z from 'zod';
import { CONTRACT_SIDES } from '@fortem-monorepo/constants';
export const contractSideSchema = z.enum(CONTRACT_SIDES);
